module.exports = __webpack_public_path__ + "assets/img/32.5c00fdcd.png";